import { AuthCallback, LoadingEllipsis, PageTitle } from '@gplibraries/react/components';
import { useEffect } from "react";
import { useNavigate } from 'react-router';

export default function AuthRedirect() {

  const navigate = useNavigate();

  // If the auth redirect doesn't kick in after 15 seconds, go home.
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 15000);

    return () => clearTimeout(timer);

  }, []);

  return (
    <>
      <PageTitle>Please Wait</PageTitle>
      <div>
        You are being redirected<LoadingEllipsis/>
      </div>
      <AuthCallback/>
    </>
  );
}